export enum EventFileType {
  weatherForecast = 'weather-forecast',
  eventSheet = 'event-sheet'
}
